import React from "react";
import homeImage from "../../assets/Landing page-amico.png";
import * as AlfredoComponents from "../../components";
import * as AlfredoStyles from "../../styles/global/global";

const HomePage: React.FC = () => {
  const currentHour = new Date().getHours();
  if (currentHour >= 12 && currentHour < 18) {
  } else if (currentHour >= 18) {
  } else {
  }

  return (
    <AlfredoStyles.Container>
      <AlfredoStyles.StyledImage src={homeImage} alt="Home" />
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.Welcome />
        </AlfredoStyles.FlexItem>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.LastOptions />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.FreeSpace />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default HomePage;
